class UserFacingApiError extends Error {
    name = 'UserFacingApiError';
}
export default UserFacingApiError;
